import { ComponentIds } from '@inter-ikea-core/core';
import { isOfType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, InteriorComponent, HideFromAssemblyInstructionsComponent, OuterMeasurementsComponent, ProductType, AssemblyInstructionsComponent, HideInSeeThroughSystemComponent, DistanceMeasurementComponent } from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
export const billyComponentResolver = (_coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.BILLY_FRAME_WITH_SHELVES_ASM,
        ProductType.BILLY_DOOR_ASM,
        ProductType.BILLY_SHELF,
        ProductType.BILLY_DRAWER,
        ProductType.BILLY_DESK,
        ProductType.BILLY_FRAME_EXTENSION,
        ProductType.BILLY_CORNER_FITTING
    ]);
    //Should include all product types that should added to the scene
    const isPlannerProduct = isOfType([
        ProductType.BILLY_FRAME_WITH_SHELVES_ASM,
        ProductType.BILLY_DOOR_ASM,
        ProductType.BILLY_SHELF,
        ProductType.BILLY_DRAWER,
        ProductType.BILLY_DESK,
        ProductType.BILLY_FRAME_EXTENSION
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.BILLY_FRAME,
        ProductType.BILLY_DOOR,
        ProductType.BILLY_FRAME_EXTENSION
    ]);
    const isInterior = isOfType([
        ProductType.BILLY_SHELF,
        ProductType.BILLY_DRAWER,
        ProductType.BILLY_DESK
    ]);
    const shouldHaveInnerDistanceMeasurement = isOfType([ProductType.BILLY_SHELF]);
    const shouldBeRemovedFromAssemblyImages = isOfType([
        ProductType.BILLY_DOOR_ASM,
        ProductType.BILLY_DOOR
    ]);
    const shouldHaveAssemblyInstructions = isOfType([
        ProductType.BILLY_FRAME_WITH_SHELVES_ASM,
        ProductType.BILLY_FRAME_EXTENSION
    ]);
    const componentBuilder = {
        build: (entity) => {
            if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.LEFT, Direction.RIGHT], [], true));
            }
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveInnerDistanceMeasurement(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN]));
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (shouldBeRemovedFromAssemblyImages(entity)) {
                entity.addComponent(new HideFromAssemblyInstructionsComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=billyComponentResolver.js.map